module.exports = __webpack_public_path__ + "img/UTRAPT.2862a13c.png";